$(function () {

    var searchMenuOpenDelay
    var searchMenuCloseDelay

    $(".search-form").click(function () {
        $(".search-form").find('input').focus();
        $(".navbar-nav a").addClass("font-fade");
        clearTimeout(searchMenuCloseDelay);
        searchMenuOpenDelay = setTimeout(function () {
            $('.js-nav-left li').hide();
        }, 200);

    })
    ;

    $("#search").focusout(function () {
        clearTimeout(searchMenuOpenDelay);
        searchMenuCloseDelay = setTimeout(function () {
            $(".navbar-nav a").removeClass("font-fade");
            $('.js-nav-left li').show();
        }, 400);
        $(".form-group.has-feedback").removeClass("search-form-big");

    })
    ;
});

$(function () {

    $('#search').click(function () {
        $('.search-results').removeClass("hide");
        $('.search-results').addClass("show");
        $('#search').addClass("triggered");
        $('#search').removeClass("not-triggered");
    });

    $("body").click(function () {
        $('.search-results').removeClass("show");
        $('.search-results').addClass("hide");
        $('#search').removeClass("triggered");
        $('#search').addClass("not-triggered");
    });

    $(".search-results").click(function (e) {
        e.stopPropagation();
    });

    $(".not-triggered").click(function (e) {
        e.stopPropagation();
    });

});
